export default "__VITE_ASSET__D1y5G8sA__"